import React, { useEffect, useState } from 'react';
import queryString from 'querystring';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { GetTitle } from './boardTitle';
import { getBreadScrumb } from './breadscrumb';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';
import { BoardItem, BoardReply } from './type/boardListItem';

export function BoardView(routeProps: any) {
  const option: any = queryString.decode(routeProps.location.search.substring(1));
  const [boardItem, setBoardItem] = useState<any>();
  const [deleted, setDelete] = useState(true);
  const [update, setUpdate] = useState(true);
  const [replie, setReplie] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [downloadError, setDownloadError] = useState(false);
  const viewButton = window.localStorage.getItem('token') !== null;
  const loginID = window.localStorage.getItem('username');
  const boardWriterID = routeProps.location.state.userId;
  const admin = window.localStorage.getItem('authority') === 'A';
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (window.localStorage.getItem('token') === null && option.ctgy === 'qna') {
      dispatch(toast.error({ message: '로그인이 필요합니다.' }));
      history.push('/login');
    } else {
      if (option.ctgy === 'qna') {
        setReplie(true);
      }
      server.getBoardItem(option.ctgy, option.id).then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setBoardItem(payload);
        }
      });
      if (
        viewButton &&
        routeProps.location.state !== undefined &&
        routeProps.location.state.delete !== undefined &&
        routeProps.location.state.delete
      ) {
        setDelete(routeProps.location.state.delete);
      }
      if (
        // 동일 계정일 경우 수정 가능 하도록 수정
        viewButton &&
        routeProps.location.state !== undefined &&
        routeProps.location.state.update !== undefined &&
        routeProps.location.state.update
      ) {
        setUpdate(routeProps.location.state.update);
      }
      if (
        viewButton &&
        routeProps.location.state !== undefined &&
        routeProps.location.state.replie !== undefined &&
        routeProps.location.state.replie
      ) {
        setReplie(routeProps.location.state.replie);
      }
    }
  }, []);

  const attachFile = (fileList: string[], fileUrl: string[]) => {
    const ret: any = [];

    for (let i = 0; i < fileList.length; i++) {
      if (fileList[i].length !== 0) {
        ret.push(
          <li
            key={i}
            onClick={() =>
              download(`${process.env.REACT_APP_API_URL}/public${fileUrl[i]}`, fileList[i])
            }
          >
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            {fileList[i]}
            {/* <a
              href={`${process.env.REACT_APP_API_URL}/public${fileUrl[i]}`}
              className="btn-file"
              download="text"
            > */}
            {/* 
            </a> */}
          </li>
        );
      }
    }
    return ret;
  };

  const download = (url: any, name: any) => {
    if (!url) {
      throw new Error('DownloadError');
    }
    setFetching(true);
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        setFetching(false);
        const blobURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobURL;
        if (name && name.length) a.download = name;
        document.body.appendChild(a);
        a.click();
      })
      .catch(() => setDownloadError(true));
  };

  const getDeleteButton = () => {
    if (deleted)
      return (
        <button
          className="btn-sub"
          type="button"
          onClick={() => {
            if (window.confirm('정말 삭제하시겠습니까?')) {
              server
                .deleteBoard(option.ctgy, option.id)
                .then((payload) => {
                  setDelete(payload);
                  routeProps.history.push(`/board/${option.ctgy}`);
                })
                .catch((error) => {
                  console.log('삭제 실패하였습니다.', error);
                });
            }
          }}
        >
          삭제
        </button>
      );

    return <></>;
  };
  const getUpdateButton = () => {
    if (update)
      return (
        <button
          type="button"
          onClick={() => {
            const op = {
              ...option,
              update: true,
            };
            routeProps.history.push({
              pathname: '/board/boardWriter',
              search: `?${new URLSearchParams(op).toString()}`,
              state: boardItem,
            });
          }}
        >
          수정
        </button>
      );
    return <></>;
  };
  const getReplieButton = () => {
    if (replie)
      return (
        <button
          type="button"
          onClick={() => {
            const op = {
              ...option,
              reply: true,
            };
            routeProps.history.push({
              pathname: '/board/replyWriter',
              search: `?${new URLSearchParams(op).toString()}`,
            });
          }}
        >
          답글
        </button>
      );
    return <></>;
  };
  const getButton = () => {
    return (
      <div className="view-footer">
        <button
          className="btn-sub"
          type="button"
          onClick={() => {
            if (option.ctgy === 'lecture-lib') {
              routeProps.history.push(`/professor/lecture-material`);
            } else {
              routeProps.history.push(`/board/${option.ctgy}`);
            }
          }}
        >
          목록
        </button>
        {loginID === boardWriterID && getDeleteButton()}
        {admin || (loginID === boardWriterID && getUpdateButton())}
        {admin && getReplieButton()}
      </div>
    );
  };
  return (
    <div className="content">
      {getBreadScrumb(option.title?.toString())}
      {GetTitle(
        option.ctgy,
        option.title?.toString(),
        option.subTitle?.toString(),
        '',
        '',
        false,
        () => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {}
      )}
      <div className="view-content">
        <div className="view-header">
          <div className="view-title">{boardItem?.subject ? boardItem.subject : ''}</div>
          <div className="writer">{boardItem?.writer?.name}</div>
          <ul>
            <li className="date">
              {boardItem === undefined ? '' : new Date(boardItem.modDate).toLocaleDateString()}
            </li>
            <li className="views">{boardItem?.hit}</li>
          </ul>
          {boardItem?.attach || (
            <ul className="files">
              <li>
                <svg
                  className="ico-file"
                  xmlns="http://www.w3.org/2000/svg"
                  height="18"
                  viewBox="0 0 24 24"
                  width="18"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
                </svg>
                <span>첨부파일:</span>
              </li>
              {attachFile(
                [
                  boardItem?.attach1 !== undefined ? boardItem.attach1 : '',
                  boardItem?.attach2 !== undefined ? boardItem.attach2 : '',
                  boardItem?.attach3 !== undefined ? boardItem.attach3 : '',
                  boardItem?.attach4 !== undefined ? boardItem.attach4 : '',
                  boardItem?.attach5 !== undefined ? boardItem.attach5 : '',
                ],
                [
                  boardItem?.attach1 !== undefined ? boardItem.attach1Url : '',
                  boardItem?.attach2 !== undefined ? boardItem.attach2Url : '',
                  boardItem?.attach3 !== undefined ? boardItem.attach3Url : '',
                  boardItem?.attach4 !== undefined ? boardItem.attach4Url : '',
                  boardItem?.attach5 !== undefined ? boardItem.attach5Url : '',
                ]
              )}
            </ul>
          )}
        </div>
        <div className="description">
          {boardItem?.content.split('\n').map((line: any) => {
            return (
              <div key={Math.random()}>
                {line}
                <br />
              </div>
            );
          })}
        </div>
      </div>
      {getButton()}
    </div>
  );
}
